import React from 'react';

import { Button } from '@randajan/jet-react/dom/form';

import "./GrantButton.scss";
import { Say } from '../../../../../arc/locale/consts.js';
import { Locale } from '../../../../assets/Locale';
import { ImgStore } from '../../../../elements/ImgStore/ImgStore';

export const GrantButton = (props) => {
    const { name, onSubmit, lock } = props;
    const say = Locale.use();

    const labelUni = say("oauthGrantButtonLabel");
    const labelName = say.or(Say.id("oauth", "grantButton", "label", name), String.jet.capitalize(name));


    return (
        <Button className="GrantButton" onSubmit={onSubmit} lock={lock}>
            <ImgStore src={`oauthGrant${String.jet.capitalize(name)}.webp`}/>
            <p>
                <span className="title">{labelUni.replace("$", labelName)}</span>
                {lock && <span className="note">{say("oauthGrantButtonLock")}</span>}
            </p>
        </Button>
    )
}

